module.exports = __webpack_public_path__ + "static/media/file-css.2170aea1.svg";